import axios from 'axios';
import BaseApi from './base';
import {
    GET_TEST,
    SAVE_TEST,
} from '../constants/api';

export default class extends BaseApi {
    static getTestsById(id) {
        return axios.get(GET_TEST + `/${id}`);
    }

    static saveTest(data) {
        return axios.post(SAVE_TEST, data);
    }
}